import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { IRoute } from '../../models/iroute.interface';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for collections
 */
export class CollectionsRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.Finance;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        const routeList: IRoute[] = [];

        switch (businessTransactionTypeId) {
            case 1138: {
                return this.getCollectionsPaymentTabRoutes();
            }
            default: {
                throw new Error('The business transaction type does not have its route list configured in the (area)-route-builder service');
            }
        }

        return routeList;
    }

    private getCollectionsPaymentTabRoutes(): TabObject[] {

        return [
            { name: 'collections-payment', title: 'Services', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }
}
